module.exports = __webpack_public_path__ + "img/banner.af2bc408.jpg";